import { restManager } from '@/plugin/restManager.js';

const productTypeStore = {
  namespaced: true,
  state: () => ({
    productTypeCode: '',
    productTypeGroups: []
  }),
  mutations: {
    setProductType: (state, payload) => {
      Object.assign(state, { productTypeCode: payload });
    },
    setGroups: (state, payload) => {
      Object.assign(state, { productTypeGroups: payload });
    }
  },
  actions: {
    setProductTypeAction: ({ commit }, payload) => {
      commit('setProductType', payload);
      sessionStorage.setItem('productTypeCode', payload);
    },
    setProductTypeGroups: async ({ commit }) => {
      try {
        const result = await restManager.product.getProductTypeMonitoringStatus();
        commit('setGroups', result);
      } catch (e) {
        commit('setGroups', []);
      }
    }
  },
  getters: {
    getProductType: (state) => {
      return state.productTypeCode || sessionStorage.getItem('productTypeCode');
    },
    getProductTypeGroups: (state) => state.productTypeGroups
  }
};
export default productTypeStore;
